<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Cập nhập Agent</h1>
      <div class="float-right">
        <router-link to="/agent" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-arrow-back"></i> Quay lại
        </router-link>
        <button class="f12 font-medium btn btn-primary" @click="submitForm">
          <i class="bx bx-save"></i> Luu
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="agentCreate">
        <form @submit.prevent>
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <h1 class="form-inner-heading">Thông tin chung</h1>
              <ValidationProvider
                name="Họ và tên"
                rules="required|minMAxAgentName"
                v-slot="{ errors }"
              >
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Họ và tên</label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      v-model="formUpdate.name"
                      :class="`form-control ${errors[0] ? 'input-err' : ''}`"
                      placeholder="Nhập họ và tên"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Tên đăng nhập</label>
                <div class="col-sm-7">
                  <input
                    type="email"
                    :value="formUpdate.email"
                    readonly
                    class="form-control"
                    placeholder="Email công ty"
                  />
                </div>
              </div>
              <ValidationProvider name="Số điện thoại" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Số điện thoại</label>
                  <div class="col-sm-7">
                    <input
                      type="tel"
                      v-model="formUpdate.phone"
                      :class="`form-control ${errors[0] ? 'input-err' : ''}`"
                      placeholder="Nhập số điện thoại"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Địa chỉ</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="formUpdate.address"
                    class="form-control"
                    placeholder="Nhập địa chỉ"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Tỉnh/ thành phố</label>
                <div class="col-sm-7">
                  <Select2
                    @change="getDistrict($event)"
                    id="tinhtp"
                    v-model="formUpdate.district"
                    :options="city"
                  ></Select2>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Quận/Huyện </label>
                <div class="col-sm-7">
                  <Select2 id="quanhuyen" v-model="formUpdate.cityId" :options="district"></Select2>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{ close }">
        <button type="button" class="btn btn-light" @click="close()" data-dismiss="modal">
          Đóng
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { ContractService } from '@/services/contract.service'
  import { mapGetters } from 'vuex'

  export default {
    name: 'agentCreate',
    data() {
      return {
        toastModal: {
          success: false,
          show: false,
          title: null,
          content: null,
        },
        city: [],
        district: [],
        formUpdate: {
          agentId: null,
          address: null,
          cityId: null,
          codeAgent: null,
          district: null,
          email: null,
          name: null,
          phone: null,
          stateAgent: null,
          typeAgent: null,
          userUpdate: JSON.parse(localStorage.getItem('userData')).userId,
          userName: null,
        },
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      this.fetchData()
      this.getCity()
    },
    methods: {
      async fetchData() {
        try {
          this.loading = true
          const data = await AgentService.getOneAgent({ agentId: this.$route.params.id })
          console.log(data)
          if (data.success) {
            const dataAgent = data.data
            this.formUpdate.address = dataAgent.address
            this.formUpdate.agentId = dataAgent.agentId
            this.formUpdate.cityId = dataAgent.cityId
            this.formUpdate.codeAgent = dataAgent.codeAgent
            this.formUpdate.district = dataAgent.district
            this.formUpdate.email = dataAgent.email
            this.formUpdate.name = dataAgent.name
            this.formUpdate.phone = dataAgent.phone
            this.formUpdate.stateAgent = dataAgent.stateAgent
            this.formUpdate.typeAgent = dataAgent.typeAgent
            this.formUpdate.userName = dataAgent.userName
            this.getDistrict(this.formUpdate.district)
            return
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
        await this.$router.push('/agent')
      },

      async getCity() {
        await ContractService.getAllCity({}).then(response => {
          if (response.success) {
            this.city = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },
      async getDistrict(cityCode) {
        await ContractService.getDistictByCode({ cityCode }).then(response => {
          if (response.success) {
            this.district = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },
      setToast(title, content, success) {
        this.toastModal.show = true
        this.toastModal.title = title
        this.toastModal.content = content
        this.toastModal.success = success
      },
      submitForm() {
        const observer = this.$refs.agentCreate
        observer
          .validate()
          .then(async success => {
            if (success) {
              this.formUpdate.userName = this.formUpdate.email
              await AgentService.updateAgent(this.formUpdate).then(response => {
                if (response.success) {
                  this.setToast(null, 'Cập nhập agent thành công!', true)
                  setTimeout(() => {
                    this.$router.push('/agent')
                  }, 1000)
                  return
                }
                this.setToast(null, response.message, false)
              })
            }
          })
          .catch(error => {
            this.setToast(null, error, false)
          })
      },
    },
  }
</script>
